import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-modal-np-compact-pack-info',
  templateUrl: './modal-np-compact-pack-info.component.html',
  styleUrls: ['./modal-np-compact-pack-info.component.scss']
})
export class ModalNpCompactPackInfoComponent {
  @Input() npCompactPackBoxPrice: string;
  @Output() compactPackAgree: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() compactPackNotAgree: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isModalShow: boolean = false;
  public isDarkBackground: boolean = false;

  show() {
    this.isModalShow = true;
    this.isDarkBackground = true;
  }

  notAgree() {
    this.closeModal();
    this.compactPackNotAgree.emit();
  }

  agree() {
    this.closeModal();
    this.compactPackAgree.emit();
  }

  closeModal() {
    this.isModalShow = false;
    this.isDarkBackground = false;
  }
}